module.exports = __webpack_public_path__ + "img/students4_new.4143169a.png";